
import { formatPrice, prettyLicenseName } from '~/utils/helpers'

export default {
  filters: { formatPrice, prettyLicenseName },
  props: {
    diagram: { type: Object, default: () => ({}) },
    licenses: { type: Array, default: () => [] }
  },
  data: () => ({
    licenseOpen: false,
    selectedLicense: 1,
    licencesOpen: false
  }),
  computed: {
    licensedPrice () {
      try {
        return this.diagram.price * this.license.multiplier
      } catch (e) {
        return this.diagram.price
      }
    }
  },
  methods: {
    licenceSwitch (license) {
      if (this.licenseOpen) {
        this.$emit('license-selected', { license })
        this.selectedLicense = license ? license.id : null
        this.licenseOpen = false
      } else {
        this.licenseOpen = true
      }
    }
  }
}
